import styled from 'styled-components';

import { Box } from '../../common/ui/Box';
import { theme } from '../../common/ui/theme';

export const SsoBanner = styled(Box).attrs({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
})`
    background-color: ${theme.colors.background.subtle};
    width: 100%;
    padding: ${theme.space[32]};
    border-radius: 8px;
`;
